export default __webpack_public_path__ + "static/media/santa.fea03ac6.png";